import 'reflect-metadata';
import { Area } from './area';
import { jsonObject, jsonMember, jsonArrayMember, toJson, TypedJSON } from 'typedjson';

@jsonObject
@toJson
export class Blur {
  @jsonMember(String) photo?: string;
  @jsonMember(Number) begin?: number;
  @jsonMember(Number) end?: number;
  @jsonMember(Boolean) noEnd?: boolean;
  @jsonMember(Area) area!: Area;
}

export const serializer = new TypedJSON(Blur);
